import React, { useEffect, useState } from "react";
import { getPackagePrices, getPackageSizes } from "../../../api/axios/requests";
import { formatCurrency } from "../../../helpers/utils";

export default function DeliverySizeCardList({
  districtId,
  selected,
  onSelect,
}) {
  const [sizes, setSizes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchSizes() {
      setLoading(true);
      try {
        let data = [];
        if (districtId) {
          const res = await getPackagePrices(districtId);
          data = res?.data || [];
        } else {
          const res = await getPackageSizes();
          data = res?.data || [];
          data = data.map((item) => ({ ...item, price: null }));
        }
        setSizes(data);
      } catch (err) {
        console.error("Ачааны төрөл татахад алдаа гарлаа:", err);
        setSizes([]);
      } finally {
        setLoading(false);
      }
    }

    fetchSizes();
  }, [districtId]);

  return (
    <div className="row">
      {(loading ? Array(3).fill(null) : sizes).map((item, idx) => (
        <div
          key={item?.id || idx}
          className="col-md-4 mb-3"
          onClick={() => !loading && onSelect(item.id, item)}
          style={{ cursor: loading ? "default" : "pointer" }}
        >
          <div className="border rounded p-3 h-100">
            {loading ? (
              <>
                <div className="placeholder-glow mb-2">
                  <span className="placeholder col-6 py-2 rounded" />
                </div>
                <div className="placeholder-glow mb-2">
                  <span className="placeholder col-8 py-2 rounded" />
                </div>
                <div className="placeholder-glow">
                  <span className="placeholder col-10 py-2 rounded" />
                </div>
              </>
            ) : (
              <>
                <div className="form-check mb-1">
                  <input
                    type="radio"
                    id={`size-${item.id}`}
                    name="shippingOptions"
                    className="form-check-input"
                    checked={selected === item.id}
                    onChange={() => onSelect(item.id, item)}
                  />
                  <label
                    htmlFor={`size-${item.id}`}
                    className="form-check-label fw-bold"
                  >
                    {item.label}
                    {item.price !== null && ` - ${formatCurrency(item.price)}`}
                  </label>
                </div>
                <p className="mb-0 text-muted">{item.desc}</p>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
